import { Button, Form, Input, message } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import { selectUser } from "../../../../auth/states/userSlice";
import { setModal } from "../../../../common/slices/commonSlice";
import LoadingIndicator from "../../../../components/common/spinner/LoadingIndicator";
import { useCreateAirlineMutation } from "../Endpoints/airlineEndpoints";
import { IAirlineFormData } from "../types/AirlinesTypes";

const AddNewAirline = ({ airLineNameList }: { airLineNameList: string[] }) => {
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);

  const [form] = Form.useForm();
  const [addAirline, { isSuccess, isLoading }] = useCreateAirlineMutation();
  useEffect(() => {
    if (isSuccess) {
      dispatch(setModal(false));
      form.resetFields();
    }
  }, [isSuccess]);

  const handleSubmit = async (values: IAirlineFormData) => {
    const body: IAirlineFormData = {
      ...values,
      airlines_created_by: user?.user_id as number,
    };
    await addAirline(body);
  };
  return (
    <Form
      layout="horizontal"
      form={form}
      labelAlign="left"
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 16 }}
      onFinish={handleSubmit}
    >
      <Form.Item
        label="Airline Name"
        name="airline_name"
        rules={[
          { required: true, message: "Please enter airline name!" },
          { max: 75, message: "Maximum 75 characters" },
          {
            validator(_, value) {
              if (value) {
                if (airLineNameList.includes(value.trim())) {
                  return Promise.reject("AirLine Name is already Exist");
                } else {
                  return Promise.resolve();
                }
              } else {
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        <Input placeholder="Enter Airline Name" />
      </Form.Item>
      <Form.Item
        label="Airline Code"
        name="airline_code"
        rules={[{ required: true, message: "Please enter airline code!" }]}
      >
        <Input placeholder="Enter Airline Code" />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 9, span: 16 }}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Submit
        </Button>
      </Form.Item>
      {isLoading && <LoadingIndicator />}
    </Form>
  );
};

export default AddNewAirline;
